import { Stack, Typography } from "@mui/material";
import { Button } from "components/UI";
import { useFinanceSettingsStore } from "features/finances";
import { ApproverTable } from "../Tables";

export const ChooseApprover = () => {
  const openCreateApproverModal = useFinanceSettingsStore(
    state => state.openCreateApproverModal
  );

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          Choose Approver
        </Typography>
        <Typography variant="caption" textAlign="center">
          Select 3 authorized person from system user to review and <br />{" "}
          approve finance request. you can also send invitations.
        </Typography>
        <Button onClick={openCreateApproverModal}>Choose approver</Button>

        <Stack alignSelf="stretch">
          <ApproverTable onboarding />
        </Stack>
      </Stack>
    </>
  );
};
